import { useCallback, useEffect, useState } from "react";
import { registerSW } from "virtual:pwa-register";

interface PwaUpdateState {
  offlineReady: boolean;
  updateAvailable: boolean;
  applyUpdate: () => void;
}

/** Registers the offline cache while keeping version activation user-controlled. */
export function usePwaUpdate(): PwaUpdateState {
  const [offlineReady, setOfflineReady] = useState(false);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updateServiceWorker, setUpdateServiceWorker] = useState<
    ((reloadPage?: boolean) => Promise<void>) | null
  >(null);

  useEffect(() => {
    const update = registerSW({
      immediate: true,
      onOfflineReady: () => setOfflineReady(true),
      onNeedRefresh: () => setUpdateAvailable(true),
    });
    setUpdateServiceWorker(() => update);
  }, []);

  /** Activates the waiting worker only after the user confirms the update. */
  const applyUpdate = useCallback(() => {
    if (updateServiceWorker !== null) {
      void updateServiceWorker(true);
    }
  }, [updateServiceWorker]);

  return { offlineReady, updateAvailable, applyUpdate };
}
